export default {
    init() {
        this.yourOrderUpload();
        this.deleteFileFromList();
    },


    yourOrderUpload(){
        // $("body").on("click", '.order-accepted-upload', function (e) {

        $('.order-accepted-upload-import').change(function() {
            $(this).closest('.order-accepted-upload-wrap').remove();
            var filesList = $('.order-accepted-upload-imported--list');
            var file = $(this)[0].files[0]; // Get the first selected file
            filesList.empty(); // Clear previous contents

            // Check if a file is selected
            if (file) {
                // Append the file name to the filesList div
                filesList.append(`<div class="item">${file.name} <span data-name="${file.name}"></span></div>`);
            }
        });
        // });
    },

    deleteFileFromList() {
        $('.import-body--upload-row--list .item span').on('click', function () {
            $(this).parent().remove();
            $('.import-file').val('');
            $('.import-body--upload-row--upload-box').addClass('invalid');
        });
    },

}